export const checkoutSummary = () => ({
    formatCurrency(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currency: 'USD'
        });
        return formatter.format(amount);
    },
})

export const checkoutSummaryActions = () => ({
    async update(platform, id) {
        this.item[platform] = id
        const payload = {
            item: this.item.item,
            web: this.item.web,
            desktop: this.item.desktop,
            app: this.item.app
        }
        const response = await fetch('/cart', { method: 'PATCH', body: JSON.stringify(payload )})
        const data = await response.json()
        this.$store.cart.replace(data.cart)
        this.$store.cart.setPrices(data.prices)
        // If we just removed the last item => Reload the page
        if (this.$store.cart.data.length === 0) {
            document.location.reload()
        }
    },
    async remove() {
        const response = await fetch('/cart', {
            method: 'DELETE',
            body: JSON.stringify({ item: this.item.item} )
        })
        const data = await response.json()
        this.$store.cart.replace(data.cart)
        this.$store.cart.setPrices(data.prices)
        // If we just removed the last item => Reload the page
        if (this.$store.cart.data.length === 0) {
            document.location.reload()
        }
    },
    handleSelected(event) {
        console.log({event: event.detail, target: event.target})
        this.update(event.detail.platform, event.detail.id)
    },
    getOption(options, id) {
        for (const option of options) {
            if (option.id === id) {
                return option
            }
        }
        return false
    },
    get desktopLabel() {
        if (this.item.desktop === 'none') {
            return '0 Users';
        } else {
            const option = this.getOption(this.$store.cart.constants.desktopOptions, this.item.desktop)
            if (option.quantity === 1) {
                return '1 User';
            } else {
                return `${option.quantity} Users`;
            }
        }
    },
    get webLabel() {
        if (this.item.web === 'none') {
            return '0 Views/mo';
        } else {
            const option = this.getOption(this.$store.cart.constants.webOptions, this.item.web)
            return `${option.quantity} Views/mo`;
        }
    },
    get appLabel() {
        if (this.item.app === 'none') {
            return '0 Apps';
        } else {
            const option = this.getOption(this.$store.cart.constants.appOptions, this.item.app)
            if (option.quantity === 1) {
                return '1 App';
            } else {
                return `${option.quantity} Apps`;
            }
        }
    },
    get undiscountedItalicsPrice() {
        const undiscountedPrice = this.item.price.net / this.$store.cart.constants.italicDiscount;
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currency: 'USD'
        });
        return formatter.format(undiscountedPrice);
    }
})